var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('div',{staticStyle:{"padding-top":"54px"}},[_c('el-collapse',{attrs:{"accordion":""}},_vm._l((_vm.filtrati),function(item,index){return _c('elCerca',{key:item.id,attrs:{"item":item,"numero":index+1}})}),1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }